<template>
  <v-layout>
    <v-flex>
      <v-combobox
        v-model="selectedValue"
        :items="categories"
        :hide-no-data="!search"
        :search-input.sync="search"
        small-chips
        outlined
        dense
        :label="$t('message.category')"
        @input="event => { $emit('input', event) }"
      >
        <template slot="no-data">
          <v-list-item>
            <span class="subheading">{{ $t('message.click_enter_add_new') }}: </span>
            <v-chip
              label
              small
            >
              {{ search }}
            </v-chip>
          </v-list-item>
        </template>
      </v-combobox>
    </v-flex>
  </v-layout>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      selectedValue: null,
      categories: [],
      loading: false,
      items: [],
      search: null
    };
  },
  created() {
    this.loading = true;
    Api()
      .get(
        "admins/academy/" +
        this.$store.state.managedAcademy +
        "/products/get/categories"
      )
      .then((response) => {
        this.categories = response.data;
        this.loading = false;
      });
  },
  mounted(){
    this.selectedValue = this.value
  },
  props: {
    value: null,
  },
  watch: {
    value: {
      handler: function(newValue) {
        this.selectedValue = newValue;
      }
    }
  },
  methods: {
    async querySelections(v) {
      this.loading = true;
      if (this.categories.length == 0) {
        var r = await Api().get("academies/distinct/categories");
        if(r.data)
          this.categories = r.data.sort();
      }
      this.items = this.categories.filter(e => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>
